(() => {
  const initialize = root => {
    if (root.dataset.dpReady) return;
    root.dataset.dpReady = 'true';
    const cards = [...root.querySelectorAll('[data-dp-card]')];
    const filters = [...root.querySelectorAll('[data-dp-filter]')];
    const status = root.querySelector('[data-dp-status]');
    const dialog = root.querySelector('[data-dp-compare-dialog]');
    const compareOpen = root.querySelector('[data-dp-compare-open]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobilePaddles = window.matchMedia('(max-width: 989px)');
    const heroVideo = root.querySelector('[data-dp-hero-video]');
    const videoToggle = root.querySelector('[data-dp-video-toggle]');
    const mobileVideo = window.matchMedia('(max-width: 749px)');
    let videoWasPaused = false;
    const videoLabel = () => {
      if (!videoToggle) return;
      videoToggle.textContent = heroVideo.paused ? videoToggle.dataset.play : videoToggle.dataset.pause;
      videoToggle.setAttribute('aria-pressed', String(!heroVideo.paused));
    };
    const loadHeroVideo = explicit => {
      if (!heroVideo || (!explicit && (reduceMotion.matches || navigator.connection?.saveData || videoWasPaused))) return;
      const source = mobileVideo.matches ? heroVideo.dataset.mobileSrc : heroVideo.dataset.desktopSrc;
      if (!source) return;
      if (heroVideo.getAttribute('src') !== source) heroVideo.src = source;
      heroVideo.muted = true;
      heroVideo.play().catch(videoLabel);
    };
    if (heroVideo) {
      heroVideo.addEventListener('play', videoLabel);
      heroVideo.addEventListener('pause', videoLabel);
      videoToggle?.addEventListener('click', () => {
        if (heroVideo.paused) { videoWasPaused = false; loadHeroVideo(true); }
        else { videoWasPaused = true; heroVideo.pause(); }
      });
      mobileVideo.addEventListener('change', () => loadHeroVideo(false));
      reduceMotion.addEventListener('change', () => { if (reduceMotion.matches) heroVideo.pause(); else loadHeroVideo(false); });
      loadHeroVideo(false);
    }
    const journalRail = root.querySelector('[data-dp-journal-rail]');
    root.querySelectorAll('[data-dp-journal-scroll]').forEach(button => button.addEventListener('click', () => {
      const journalCard = journalRail.querySelector('.dp-journal-card');
      const distance = journalCard.getBoundingClientRect().width + parseFloat(getComputedStyle(journalRail).gap);
      journalRail.scrollBy({left:Number(button.dataset.dpJournalScroll) * distance, behavior:reduceMotion.matches ? 'auto' : 'smooth'});
    }));


    const paddleGroups = [...root.querySelectorAll('[data-dp-core-group]')].map(element => ({
      element,
      rail: element.querySelector('[data-dp-rail]'),
      cards: [...element.querySelectorAll('[data-dp-card]')],
      count: element.querySelector('[data-dp-core-count]'),
      buttons: [...element.querySelectorAll('[data-dp-paddle-scroll]')]
    }));
    const updatePaddleNavigation = group => {
      const {rail, buttons} = group;
      const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
      buttons.forEach(button => {
        button.disabled = !mobilePaddles.matches || group.element.hidden ||
          (Number(button.dataset.dpPaddleScroll) < 0 ? rail.scrollLeft <= 1 : rail.scrollLeft >= maximum - 1);
      });
    };
    const updatePaddleGroup = group => {
      group.rail.tabIndex = mobilePaddles.matches ? 0 : -1;
      updatePaddleNavigation(group);
    };
    const updatePaddleLayout = () => paddleGroups.forEach(updatePaddleGroup);
    const paddleResizeObserver = new ResizeObserver(() => paddleGroups.forEach(updatePaddleNavigation));
    paddleGroups.forEach(group => {
      group.count.textContent = group.cards.length;
      group.buttons.forEach(button => button.addEventListener('click', () => {
        const card = group.cards.find(item => !item.hidden);
        if (!card) return;
        const distance = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(group.rail).columnGap) || 0);
        group.rail.scrollBy({left:Number(button.dataset.dpPaddleScroll) * distance, behavior:reduceMotion.matches ? 'auto' : 'smooth'});
      }));
      group.rail.addEventListener('scroll', () => updatePaddleNavigation(group), {passive:true});
      paddleResizeObserver.observe(group.rail);
    });
    mobilePaddles.addEventListener('change', updatePaddleLayout);
    updatePaddleLayout();

    const chosen = () => cards.filter(card => card.querySelector('[data-dp-compare]').checked);
    const setFilter = value => {
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.dpFilter === value)));
      cards.forEach(card => {
        const matchesCore = card.closest('[data-dp-core-group]')?.dataset.dpCoreGroup === value;
        card.hidden = value !== 'all' && !matchesCore && !card.dataset.dpProfile.split(/\s+/).includes(value);
      });
      paddleGroups.forEach(group => {
        const count = group.cards.filter(card => !card.hidden).length;
        group.count.textContent = count;
        group.element.hidden = count === 0;
        group.rail.scrollLeft = 0;
        updatePaddleGroup(group);
      });
      status.textContent = cards.filter(card => !card.hidden).length + ' ' + status.dataset.resultMessage;
    };
    filters.forEach(button => button.addEventListener('click', () => setFilter(button.dataset.dpFilter)));
    root.querySelectorAll('[data-dp-compare]').forEach(input => input.addEventListener('change', () => {
      if (chosen().length > 3) { input.checked = false; status.textContent = status.dataset.limitMessage; }
      const count = chosen().length;
      root.querySelector('[data-dp-compare-count]').textContent = count;
      compareOpen.disabled = count < 2;
    }));
    let comparisonTrigger = compareOpen;
    const openComparison = (trigger, selection) => {
      if (selection.length < 2) return;
      comparisonTrigger = trigger;
      const grid = root.querySelector('[data-dp-compare-grid]');
      grid.replaceChildren(...selection.map(card => card.querySelector('[data-dp-comparison]').content.cloneNode(true)));
      dialog.showModal();
    };
    compareOpen.addEventListener('click', () => openComparison(compareOpen, chosen()));
    root.querySelector('[data-dp-compare-foam]')?.addEventListener('click', event => {
      openComparison(event.currentTarget, cards.filter(card => card.hasAttribute('data-dp-featured-paddle')));
    });
    const communityRail = root.querySelector('[data-dp-community-rail]');
    root.querySelectorAll('[data-dp-community-scroll]').forEach(button => button.addEventListener('click', () => {
      const photo = communityRail.querySelector('figure');
      if (!photo) return;
      const distance = photo.getBoundingClientRect().width + parseFloat(getComputedStyle(communityRail).gap);
      communityRail.scrollBy({left:Number(button.dataset.dpCommunityScroll) * distance, behavior:reduceMotion.matches ? 'auto' : 'smooth'});
    }));
    root.querySelector('[data-dp-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
    dialog.addEventListener('close', () => comparisonTrigger.focus({preventScroll:true}));

  };
  document.querySelectorAll('[data-dpr-performance]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-dpr-performance]').forEach(initialize));
})();
